import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Page } from '../../components/views/Layouts/Page';
import { IAppState, TThunkDispatch } from '../../store';
import { recallFailedAction } from '../../store/failedAction';

export const PageContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const failedAction = useSelector((state: IAppState) => state.failedAction);

  const recallFailed = React.useCallback(() => {
    if (failedAction) {
      dispatch(recallFailedAction(failedAction));
    }
  }, [dispatch, failedAction]);

  return <Page recallFailed={recallFailed} isError={Boolean(failedAction)} />;
};
